import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Add } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../common/components';
import messages from '../../messages';

const S = {
  Add: styled(Add)`
    margin-right: 8px;
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    color: ${({ theme }) => theme.palette.primary.contrastText};
  `,
};

const ContactAddLink = ({ className, ...otherProps }) => (
  <Button
    component={Link}
    className={className}
    color="primary"
    variant="contained"
    {...otherProps}
  >
    <S.Add />
    <FormattedMessage {...messages.contactAddLink} />
  </Button>
);

ContactAddLink.propTypes = {
  className: PropTypes.string,
};

ContactAddLink.defaultProps = {
  className: undefined,
};

export default ContactAddLink;
